export default __webpack_public_path__ + "static/type-safe-css-ee933a703a1775c5c5da22819c020243.png";